module.exports = {
  "已选择": "已选择",
  "FoodC_check_HTib_sWqA": "准备下单",
  "FoodC_update_The_expected_ZzFg": "预计送达时间以平台预估的最晚预计送达时间为准。",
  "FoodC_education__2_jwSo": "（2）放在门口（文字备注）",
  "CS_page_Courier_Phone_ghUr": "骑手电话",
  "FoodC_Website_At_present_XpFw": "目前Web站暂未上线兑换功能，请前往App端进行兑换码兑换",
  "FoodC_web_Application_Progress_UYtG": "申请进度",
  "FoodC_001_The_WEB_Iizt": "WEB版本暂不支持paypay支付，使用paypay支付请下载{{download}} ",
  "FoodC_page_Upon_discovery_baTq": "一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任",
  "FoodC_homepage_Enter_delivery_IZAu": "输入配送地址",
  "FoodC_dish_Are_you_TaUN": "确认离开吗？",
  "FoodC_Card2_When_the_sFOa": "开店时间",
  "FoodC_education__1_vwgm": "（1）送货上门",
  "soda-c-i18n---早间：%s-%s": "早间：%s-%s",
  "FoodC_Storefront_iOFy_aaef": "商家暂未参与活动",
  "soda-c-i18n---延迟送达%s分钟以上": "延迟送达%s分钟以上",
  "FoodC_stores_All_stores_clRv": "全部商家",
  "FoodC_education_4_Customers_laxR": "4. 顾客需要骑手到户后10分钟内及时取餐；",
  "FoodC_dish_XX_YY_opCV": "仅剩",
  "FoodC_education__1_qvVC": "（1）顾客取餐超时",
  "soda-c-i18n---个人中心的“优惠券”": "个人中心的“优惠券”",
  "FoodC_web_Feedback_on_ookM": "网页版暂不支持相关问题的反馈，请您前往手机应用中进行操作。抱歉给您造成了不好的体验，如您仍有疑问，请联系客服帮您解决。",
  "FoodC_supplement_Return_wVpv": "返回",
  "FoodC_optimization_rmLx_bSmk": "请搜索并添加您的见面地址",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. 超时赔付服务是%s为你免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给你一定金额的优惠券，订单完成后可以在中查看。",
  "FoodC_homepage_Search_for_CiMZ": "搜索美食",
  "FoodD_suspensionpage_In_the_zGEU": "到底了",
  "FoodC_progress_Order_canceled_KDSH": "订单已取消",
  "FoodC_optimization_RLDn_cLAQ": "请添加见面地址",
  "FoodC_optimization_hksX_yevn": "请添加您的见面地址，否则将无法为您正常配送",
  "FoodC_education_Meal_picking_ziun": "取餐规则",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，",
  "Entrega_order__YnnH": "DiDi Entrega Business",
  "FoodC_education_1_Customers_Gpbb": "1. 顾客可在下单前选择交餐方式，平台会要求骑手按照顾客所选择的方式进行处理：",
  "FoodC_sales_Condition_of_lnwg": "收餐时外包装密封品状态（必填）",
  "soda-c-i18n---送您1张%s折扣券；": "送你1张%s折扣券；",
  "productname_didi_food": "滴滴外卖",
  "FoodC_education__1_mJTG": "（1）如果商家已确认接单，您可通过‘取消订单‘功能与商家协商申请取消订单；如商家因已出餐等合理理由不同意取消订单，您将不能免费取消订单；如您坚持取消订单或者拒收餐品，则订单相关费用将由您全部承担；",
  "FoodC_Page_tjhz_MdCn": "很好（{{time}})",
  "FoodC_education_Principles_of_RKEk": "取餐纠纷处理原则",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给你一定金额的优惠券，订单完成后可以在",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "DiDi Food|滴滴外卖，随时随地享受美食！",
  "soda-c-i18n---将赔付给您1张%s优惠券": "将赔付给你1张%s优惠券",
  "FoodC_Storefront_bIgB_uLGp": "本次优惠已抢光，欢迎下次再来",
  "FoodC_improvement_Rgol_abYw": "您已提交取消申请，商家最晚将在{{XminYs}}内处理，请您耐心等待。",
  "FoodC_dish_Purchase_NrCl": "购买",
  "FoodC_page_Invite_friends_oGuj": "邀请好友成为{{\t\nproductname_didi_food}}新用户，好友领取您送出的红包，并在被介绍后14天内及活动时间截止前，完成订单且无退款，无论是否使用领取的红包下单，您均可获得{{\t\nproductname_didi_food}}[优惠券]奖励",
  "FoodC_popup_After_closing_ujoW": "关闭后您将无法保存已选择的菜品和规格",
  "FoodC_page__KWIm": "知道了",
  "FoodC_remark_Enjoy_your_OvmD": "祝您用餐愉快",
  "FoodC_optimization_knQx_VpIr": "添加",
  "soda-c-i18n---超时赔付规则说明": "超时赔付规则说明",
  "FoodC_education_5_Cash_zBuY": "5. 如下现金支付订单，顾客需准备充足的现金，现金付款后取餐；",
  "FoodC_referral_Copy_link_kCti": "复制链接",
  "FoodC_sidebar_Scan_QR_ONzJ": "扫描二维码",
  "FoodC_sidebar_Use_the_huoZ": "使用APP，随时随地享有美食",
  "FoodC_education_3_If_wduh": "3. 若因产品问题、天气问题等非人为因素导致交餐纠纷，平台承担责任",
  "FoodC_web_Customer_Service_EBqf": "客服",
  "FoodC_sidebar_Update_successfully_cuyI": "更新成功",
  "FoodC_education__1_IIfh": "（1）在商家接单前，您可以在订单详情页通过‘取消订单’功能进行取消",
  "FoodC_details_Refund_Details_sGIk": "退款详情",
  "FoodC_page_This_special_fYuo": "本优惠活动仅限{{\t\nactivity_city}}开通{{\t\nproductname_didi_food}}区域",
  "FoodC_page_For_any_IWNZ": "关于本活动的任何问题，请联系{{contact_email}}客服",
  "FoodC_reasons_Enter_a_Pnzg": "请输入具体原因",
  "Groceries_1_MhVY_Etfm": "换货新商品",
  "Entrega_name_99_Flash_maAd": "99闪送",
  "FoodC_education_Basic_requirements_hIbv": "顾客取餐基本要求",
  "FoodC_202410_ZHQi_kNsP": "修改",
  "FoodC_homepage_Now_place_Kmkm": "现在下单享用送到门口的美食吧",
  "FoodC_education_In_order_SRIb": "为了使您在{{brand_name}}服务中有更好的体验，平台特制订取消规则，以供各方遵守。",
  "FoodC_1_mnqk_AcOb": "复制失败",
  "FoodC_education__4_QYXm": "（4）顾客拒绝支付现金单",
  "FoodC_Storefront_Fzba_uHgH": "无法参与",
  "FoodC_education_In_the_MKeB": "下列取消订单的情形下，您无需承担责任：",
  "FoodC_education__3_ltNM": "（3）因分配不到骑手等平台原因或外部原因导致订单取消的情形",
  "FoodC_presentation_DiDi_Delivery_vrwd": "滴滴闪送",
  "FoodC_supplement_Modify_Mobile_ZJkT": "修改手机号/修改密码/绑定邮箱/注销账户请",
  "FoodC_1_dXUH_ThDd": "查看更多",
  "soda-c-i18n---送您1张%s优惠券；": "送你1张%s优惠券；",
  "FoodD_problem_I_see_NhGG": "我知道了",
  "FoodC_sales_If_the_TsPm": "如果外包装有封条或其他密封工具（如装订针等），请您告诉我们收餐时它们是否完好。信息仅用于平台更准确地与商家和骑手核实您的问题，信息不会影响对您的处理结果。",
  "FoodOpC_backend_Copy_HxOc": "复制",
  "FoodC_Website_The_WEB_pBbW": "WEB版本暂不支持{{pay_name}}支付，使用{{pay_name}}支付请下载",
  "FoodC_Website_From_shop_Jatv": "从【shop name】点外卖，立刻下单|DiDi Food",
  "FoodC_sales_Supplementary_information_ihyk": "补充信息",
  "FoodC_202410_hAya_NcZF": "确认({{countdown}}秒)",
  "FoodC_education__2_uVUK": "（2）因商家未营业、商品售罄、发生意外等原因订单被商家或骑手取消，订单费用将全部退回；",
  "FoodC_001_This_operation_Dwog": "此操作将删除购物车，是否继续？",
  "FoodC_all_No_reward_ocGJ": "没有奖励",
  "FoodC_education_In_order_AZCw": "为了使您在{{brand_name}}服务中有更好的体验，平台特制订取餐规则，以供各方遵守。涉及顾客取餐纠纷的场景，将按照如下规则处理",
  "FoodC_page_Your_invited_sPpR": "您邀请的好友必须是{{\t\nproductname_didi_food}}新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户",
  "FoodC_optimization_GUGp_fDxe": "返回上个页面",
  "FoodC_web_Only_1_ZddK": "仅限1件",
  "FoodC_progress_Order_completed_joIL": "订单已完成",
  "FoodC_page_Rewards_are_dWeY": "奖励按照【被推荐人】定位所在城市发放",
  "FoodC_1_ScPa_MVPN": "复制成功",
  "FoodC_education__2_KZTZ": "（2）骑手联系不上顾客",
  "FoodC_education_In_the_nIgD": "下列取消订单的情形下，您需承担责任：",
  "FoodC_zhaopin_Recruitment_OZrZ": "招聘",
  "FoodC_education_Platform_Delivery_MJPQ": "平台配送",
  "FoodC_dish_New_guest_bkGC": "新客专享",
  "soda-c-i18n---将赔付给您%s张免配送费券": "将赔付给你%s张免配送费券",
  "FoodC_all_You_haven_lSmt": "你还没有邀请你的朋友，快去邀请他们吧",
  "FoodC_dish_Look_again_fJrp": "再看看",
  "FoodC_remark_Thank_you_ENoY": "感谢您使用{{brand_name}}服务",
  "FoodC_dish_Leaving_LwWJ": "离开",
  "FoodC_rule_14_Up_dovx": "每个用户每天最多用券2张",
  "FoodC_education__2_KHhl": "（2）如您超过平台规定的时间未到达交餐点、订单地址填写错误、收餐号码错误、拒接送餐人员电话、无正当理由拒收餐品，您需要支付订单费用",
  "FoodC_education_Cancellation_Policy_fxrl": "取消规则",
  "FoodC_nonaffiliate_Courier_is_iunG": "骑手正前往商家为您下单",
  "FoodC_dish_Current_activity_Iyrv": "当前活动将在{{arrived_time}}后结束，结束后您将无法购买新人专享特价菜品",
  "FoodC_dish_You_will_AXAT": "离开您将无法购买新人专享特价菜品",
  "FoodC_education_If_you_RTIV": "您成功支付外卖价款后，如需要取消订单的，将按照如下规则进行：",
  "FoodC_education_2_Receiving_gFZl": "2. 收餐地址、联系方式填写正确；",
  "soda-c-i18n---晚间：%s-%s": "晚间：%s-%s",
  "FoodC_page__iyoe": "收起",
  "FoodC_page_The_threshold_yZFq": "优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用",
  "FoodC_education__3_TDsa": "（3）顾客拒收餐品",
  "FoodC_education_2_If_SoSk": "2. 若骑手未按照平台规范完成交餐，导致交餐纠纷，优先骑手承担责任",
  "FoodC_202410_FxEp_LCxL": "支付中",
  "Groceries_web__Ovnh": "抱歉，商超店铺目前只支持在app端查看",
  "FoodC_education__unk_aOCD": "{{delivery_type}}平台规则",
  "soda-c-i18n---将赔付给您1张%s折扣券": "将赔付给你1张%s折扣券",
  "FoodC_education_1_If_iWDm": "1. 如顾客未按照上述要求取餐，导致交餐纠纷，优先顾客承担责任，具体场景包括且不限于：",
  "soda-c-i18n---送您%s张免配送费券；": "送你%s张免配送费券；",
  "FoodB_supplement_Network_connection_RVcl": "网络连接失败，请检查网络设置",
  "FoodC_page_Rewards_will_NhMd": "奖励会在邀请成功后的48小时内发放入您的账号，您可在{{\t\nproductname_didi_food}}-钱包-券中查看",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "订单实际送达时间晚于预计送达时间%s分钟以上，",
  "FoodC_education_3_Customers_Zoec": "3. 顾客需要保持手机畅通，便于骑手联系取餐；"
}